import { useMatch, useResolvedPath } from 'react-router-dom';

export const useCurrentTab = () => {
  const resolvedPathUrl = useResolvedPath('');
  const match = useMatch({ path: `${resolvedPathUrl.pathname}/:tab/*`, end: true });

  const { tab: currentTab } = match?.params || {};

  return { currentTab };
};
